import JobArchitecture from '@/views/JobArchitecture.vue';
import JobArchitectureFamily from '@/views/JobArchitectureFamily.vue';
import JobArchitectureCompare from '@/views/JobArchitectureCompare.vue';
import { checkPermissionsOrRedirect } from '@/helpers/routeMiddleware';

export const jobArchitecture = (authDataStore) => ([
  {
    path: '/job-architecture',
    name: 'job-architecture',
    component: JobArchitecture,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewJobProfileArchitecture']),
    meta: { title: 'Job Architecture' },
  },
  {
    path: '/job-architecture/family/:familyUlid',
    name: 'job-architecture-family',
    component: JobArchitectureFamily,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewJobProfileArchitecture']),
    meta: { title: 'Job Family Profiles' },
  },
  {
    path: '/job-architecture/compare',
    name: 'job-architecture-compare',
    component: JobArchitectureCompare,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewJobProfileArchitecture']),
    meta: { title: 'Compare Job Profiles' },
  },
]);
